// extracted by mini-css-extract-plugin
export var actions = "_y-0";
export var actionsContainer = "_y-7";
export var border = "_y-1";
export var childFullHeight = "_y-f";
export var collapse = "_y-2";
export var content = "_y-a";
export var contentChild = "_y-e";
export var fullscreen = "_y-c";
export var hasLeftRadius = "_y-k";
export var headerContainer = "_y-3";
export var headerRow = "_y-5";
export var hidePadding = "_y-b";
export var navCollapsedGap = "_y-l";
export var noScrollX = "_y-m";
export var noScrollY = "_y-n";
export var noTopPadding = "_y-i";
export var optOutTopPadding = "_y-d";
export var pageMain = "_y-j";
export var pageOuter = "_y-g";
export var pagePadding = "_y-8";
export var pageScroll = "_y-9";
export var profile = "_y-o";
export var profileContainer = "_y-p";
export var profileImage = "_y-q";
export var profileMain = "_y-r";
export var profileSubtitle = "_y-t";
export var profileTitle = "_y-s";
export var showLeftPadding = "_y-h";
export var tabsPortalSlot = "_y-6";
export var tabsWrapper = "_y-4";
export var title = "_y-u";